function membershipService() {
  function exportMembershipCard<IMembership>(id: string, showCredentials: boolean) {
    return `/api/membership/ExportMembershipCard?ssoUUId=${id}&memberId=${id}&showCredentials=${showCredentials}`;
  }

  function exportMembershipCertificate<IAccount>(
    id: string,
    showCredentials: boolean,
    isLetterSize: boolean
  ) {
    return `/api/membership/ExportMembershipCertificate?ssoUUId=${id}&memberId=${id}&showCredentials=${showCredentials}&isLetterSize=${isLetterSize}`;
  }

  return {
    exportMembershipCard,
    exportMembershipCertificate,
  };
}

export default membershipService;
